import { Typography } from '@material-ui/core';
import { Link as RRLink } from 'react-router-dom';
import Breadcrumb from '../Breadcrumb';
import UserAccessControl1 from './../../assets/UserAccessControl-1.png';
import HelpFooter from './HelpFooter';
import useStyles from './useStyles';
import { useTranslation } from 'react-i18next';

export default function UserAccessControl() {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <div className={classes.root}>
      <Breadcrumb
        name="topicName"
        data={{
          helpTopic: t('help.topics.permissions.label'),
          helpTopicId: 'permissions',
          topicName: t('help.subtopics.userAccessControl'),
          topicNameId: 'user-access-control'
        }}
      />
      <Typography className={classes.title} component="p" variant="h4">
        {t('help.pages.userAccessControl.title')}
      </Typography>
      <Typography variant="body1" gutterBottom>
        {t('help.pages.userAccessControl.description')}{' '}
        <RRLink to="/helps/permissions/document-access-control">
          {t('help.subtopics.documentAccessControl')}
        </RRLink>
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        <u>{t('help.userAccessControlLevel')}</u>
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        - {t('help.levels.highlyConfidential')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        - {t('help.levels.confidential')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        - {t('help.levels.internal')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        - {t('help.levels.external')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        - {t('help.levels.public')}
      </Typography>
      <img className={classes.media} src={UserAccessControl1} alt={`${t('help.stepAltPrefix')}1`} />
      <HelpFooter />
    </div>
  );
}
